import React, { type ReactNode, createContext, useState } from 'react';
import noop from 'lodash/noop';

export const ActionsMenuPopupContext = createContext({
	openPopupRef: null,
	setOpenPopupRef: noop,
});

type Props = {
	children: ReactNode;
};

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const ActionsMenuPopupProvider = ({ children }: Props) => {
	const [openPopupRef, setOpenPopupRef] = useState(null);

	return (
		<ActionsMenuPopupContext.Provider value={{ openPopupRef, setOpenPopupRef }}>
			{children}
		</ActionsMenuPopupContext.Provider>
	);
};
